export const TransactionStatus = Object.freeze({
    CANCELED: Symbol('CANCELED'),
    COMPLETED: Symbol('COMPLETED'),
    NEW: Symbol('NEW'),
    PENDING: Symbol('PENDING'),
    WAITING_FOR_CONFIRMATION: Symbol('WAITING_FOR_CONFIRMATION'),
});

/**
 * Results of this method can be used in <v-select> fields.
 */
export function getItems(value = 'value', text = 'text') {
    const items = [];
    const statuses = Object.getOwnPropertyNames(TransactionStatus);

    for (const status of statuses) {
        items.push({[value]: status, [text]: getStatusText(status)});
    }

    return items;
}

export function getStatusColor(status) {
    if ('symbol' !== typeof status) {
        status = TransactionStatus[status];
    }

    return {
        [TransactionStatus.CANCELED]: 'red--text',
        [TransactionStatus.COMPLETED]: 'green--text',
        [TransactionStatus.NEW]: '',
        [TransactionStatus.PENDING]: 'orange--text',
        [TransactionStatus.WAITING_FOR_CONFIRMATION]: 'orange--text',
    }[status];
}

export function getStatusName(status) {
    if ('symbol' !== typeof status) {
        status = TransactionStatus[status];
    }

    return {
        [TransactionStatus.CANCELED]: 'CANCELED',
        [TransactionStatus.COMPLETED]: 'COMPLETED',
        [TransactionStatus.NEW]: 'NEW',
        [TransactionStatus.PENDING]: 'PENDING',
        [TransactionStatus.WAITING_FOR_CONFIRMATION]: 'WAITING_FOR_CONFIRMATION',
    }[status];
}

export function getStatusText(status) {
    if ('symbol' !== typeof status) {
        status = TransactionStatus[status];
    }

    return {
        [TransactionStatus.CANCELED]: 'Anulowana',
        [TransactionStatus.COMPLETED]: 'Opłacono',
        [TransactionStatus.NEW]: 'Nowe',
        [TransactionStatus.PENDING]: 'W trakcie przetwarzania',
        [TransactionStatus.WAITING_FOR_CONFIRMATION]: 'Oczekuje na potwierdzenie',
    }[status];
}

export function isCancelled(status) {
    return TransactionStatus.CANCELED === TransactionStatus[status];
}

export function isNew(status) {
    return TransactionStatus.NEW === TransactionStatus[status];
}

export function isFinished(status) {
    const finalStatuses = [
        TransactionStatus.CANCELED,
        TransactionStatus.COMPLETED,
    ];

    return finalStatuses.includes(TransactionStatus[status]);
}
